// extracted by mini-css-extract-plugin
export default {"ConfirmUnsavedChangesModal":"ConfirmUnsavedChangesModal-styles__ConfirmUnsavedChangesModal__n3OAl"};